import { Component, AfterViewInit, Injectable } from "@angular/core";
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import { Menu } from "./menu";
import { first } from "rxjs/operators";
import { Router } from "@angular/router";
import { Employee } from "src/app/parametrage/core/model/employee/employee";
import { EmployeeService } from "src/app/parametrage/core/service/employee.service";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";

@Injectable({
  providedIn: "root",
})
@Component({
  selector: "app-side-bar",
  templateUrl: "./side-bar.component.html",
  styleUrls: ["./side-bar.component.scss"],
  animations: [
    trigger("slide", [
      state("up", style({ height: 0 })),
      state("down", style({ height: "*" })),
      transition("up <=> down", animate(200)),
    ]),
  ],
})
export class SideBarComponent implements AfterViewInit {
  currentEmployee: Employee = new Employee();

  MyPermissions: string[];

  menus = [];

  constructor(
    private _router: Router,
    public sidebarservice: Menu,
    private _keycloakService: KeycloakService,
    private _employeeService: EmployeeService
  ) {
    this.getCurrentEmployee();
    this.menus = sidebarservice.getMenuList();
    this.MyPermissions = _keycloakService.getAccessPermissions();
  }

  ngAfterViewInit() {}

  getCurrentEmployee() {
    this._employeeService.getCurrentEmployee().subscribe(
      (data) => {
        this.currentEmployee = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  logout() {}

  redirectUrl(url) {
    this._router.navigate([url]).then(() => {
      window.location.reload();
    });
  }

  getSideBarState() {
    return this.sidebarservice.getSidebarState();
  }

  getState(currentMenu) {
    if (currentMenu.active == "open") {
      return "down";
    } else {
      return "up";
    }
  }

  refreshHeader() {
    let header_id = localStorage.getItem("current_menu_header");

    this.menus.forEach((element) => {
      element.current_header = header_id;

      if (element.submenus != null) {
        element.submenus.forEach((elem) => {
          elem.current_header = header_id;
        });
      }
    });

    return this.menus;
  }

  toggle(currentMenu) {
    this.menus.forEach((element) => {
      if (element === currentMenu) {
        currentMenu.active = "open";
      } else {
        element.active = "";
      }
    });
  }

  toggleSubmenu(currentMenu, subMenu) {
    this.toggle(currentMenu);

    currentMenu.submenus.forEach((element) => {
      if (element === subMenu) {
        subMenu.active = "active";
      } else {
        element.active = "";
      }
    });
  }
}
